module.exports = "/images/jm.svg?9848e0ab4b98f1d19a233071e8a50042";